import { Map, OrderedMap, fromJS } from 'immutable';

import ReactionsConstants from 'Shared/constants/Reactions.constants';
import FeedbacksConstants from 'Shared/constants/Feedbacks.constants';

const initialState = Map({
  [ReactionsConstants.State.REACTIONS_BY_REACTION_SLUG]: OrderedMap(),
});

export const ReactionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ReactionsConstants.Actions.CREATE_REACTION_SUCCESS:
    case FeedbacksConstants.Actions.FETCH_FEEDBACKS_SUCCESS:
      return state.updateIn([ReactionsConstants.State.REACTIONS_BY_REACTION_SLUG], (existing = OrderedMap()) =>
        existing.merge(
          OrderedMap(
            Object.values(action.payload.reaction).map(item => {
              return [item.attributes.slug, Map(fromJS(item.attributes))];
            })
          )
        )
      );
    case ReactionsConstants.Actions.DELETE_REACTION_SUCCESS:
      return state.deleteIn([ReactionsConstants.State.REACTIONS_BY_REACTION_SLUG, action.payload.reactionSlug]);
    default:
      return state;
  }
};
